<template>
    <div class="main">
      <div class="container banner">
        <img src="../../static/img/banner-index.png" alt="常州合美月子中心">
        <div class="content">
          <ul>
            <router-link tag="li" to="/describe" class="server-nine first">六大<br>服务</router-link>
            <router-link tag="li" to="/describe" class="server-nine"><div class="transition"><img class="cate-icon" src="../../static/img/index/cate-icon1.png" alt=""></div></router-link>
            <router-link tag="li" to="/describe" class="server-nine"><div class="transition"><img class="cate-icon" src="../../static/img/index/cate-icon2.png" alt=""></div></router-link>
            <router-link tag="li" to="/describe" class="server-nine"><div class="transition"><img class="cate-icon" src="../../static/img/index/cate-icon3.png" alt=""></div></router-link>
            <router-link tag="li" to="/describe" class="server-nine"><div class="transition"><img class="cate-icon" src="../../static/img/index/cate-icon4.png" alt=""></div></router-link>
            <router-link tag="li" to="/describe" class="server-nine"><div class="transition"><img class="cate-icon" src="../../static/img/index/cate-icon5.png" alt=""></div></router-link>
            <router-link tag="li" to="/describe" class="server-nine"><div class="transition"><img class="cate-icon" src="../../static/img/index/cate-icon6.png" alt=""></div></router-link>
          </ul>
      </div>
        <div style="clear: both"></div>
      </div>
      <div class="container meal bg-1">
        <div class="content ">
          <h3 class="meal-title"><span class="title-line"></span>合美环境<span class="title-line"></span></h3>
          <p class="sub-title">Environmental science</p>
          <p class="sub-title-f">【品质服务 如家环境】</p>
          <el-radio-group v-model="tabPosition" style="margin-bottom: 30px;">
            <el-radio-button label="all">品质套餐</el-radio-button>
            <el-radio-button label="recover">5A环境</el-radio-button>
            <el-radio-button label="major">五星配套</el-radio-button>
            <el-radio-button label="top">多功能房</el-radio-button>
          </el-radio-group>
          <div class="ab-containers">
            <div  class="flex-content" v-if="tabPosition=='all'">
              <div class="envi" v-for="item in meatListA" :key="item.id" name="item.id">
                <img :src="item.src" alt="">
                <p class="env-name">{{item.title}}</p>
                <p class="env-info">{{item.occupancy}}</p>
                <p class="env-info">{{item.sub}}</p>
              </div>
            </div>
            <div class="flex-content" v-if="tabPosition=='recover'">
              <div class="envi" v-for="item in meatListB" :key="item.id" name="item.id">
                <img :src="item.src" alt="">
                <p class="env-name">{{item.title}}</p>
                <p class="env-info">入住率：<span>{{item.occupancy}}</span>  入住环境</p>
<!--                <el-button>预定套餐</el-button>-->
              </div>
            </div>
            <div class="flex-content" v-if="tabPosition=='major'">
              <div class="envi" v-for="item in meatListC" :key="item.id" name="item.id">
                <img :src="item.src" alt="">
                <p class="env-name">{{item.title}}</p>
                <p class="env-info">入住率：<span>{{item.occupancy}}</span>  入住环境</p>
<!--                <el-button>预定套餐</el-button>-->
              </div>
            </div>
            <div class="flex-content" v-if="tabPosition=='top'">
              <div class="envi" v-for="item in meatListD" :key="item.id" name="item.id">
                <img :src="item.src" alt="">
                <p class="env-info">{{item.title}}</p>
<!--                <el-button>预定套餐</el-button>-->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container sp-server">
        <div class="content">
          <div class="left-part">
            <h3 class="meal-title"><span class="title-line"></span>精选服务<span class="title-line"></span></h3>
            <p class="sub-title">Selected services</p>
            <p class="sub-title-f">【用心关爱 快乐分享】</p>
            <div class="colocation">
              <ul class="colo-list">
                <li class="colo-item" v-for="(item,index) in spList" :key="item.id" @click="setActiveS(index)">
                  <div class="out-img">
                    <img :src="item.img" alt="">
                    <div class="hide" v-if="item.ifHide"></div>
                  </div>
                  <p class="colo-intro">{{item.name}}</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="right-part">
            <el-carousel indicator-position="none" ref="carousels"  arrow="never" height="600px">
              <el-carousel-item v-for="item in jxServer" :key="item.id" name="item.id">
                <div class="right-content">
                  <p class="right-title">
                    <span class="title-line"></span>
                    {{item.name}}
                    <span class="title-line"></span>
                  </p>
                  <div class="sp-article" v-html="item.content">

                  </div>
                  <div class="img-part">
                    <img :src="item.picUrl" alt="">
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <div class="container diary">
        <div class="content">
          <h3 class="meal-title"><span class="title-line"></span>合美特色<span class="title-line"></span></h3>
          <p class="sub-title">Brand characteristics</p>
          <p class="sub-title-f">【专业呵护 专注完美】</p>
          <div class="taggle-box">
            <ul>
              <li class="fun-carousel"  v-for="item in diaryCarList" :key="item.id">
                <i @click="setActive(item.id)" :class="{'active':item.id===index?true:false}">{{item.name}}</i>
                <span v-if="item.id !==5">/</span>
              </li>
            </ul>
          </div>
          <div style="clear: both"></div>
          <el-carousel indicator-position="none" ref="diaryCar" arrow="never" height="470px" :autoplay="false" >
            <el-carousel-item v-for="(item,index) in diaryList" :key="index" name="item.id">
              <div class="diary-carousel">
                <img :src="item.src" alt="">
                <div class="diary-content">
                  <h3 class="diary-title">{{item.title}}</h3>
                  <div class="diary-article">{{item.content}}</div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="container knowledge">
        <div class="content">
          <h3 class="meal-title"><span class="title-line"></span>团队力量<span class="title-line"></span></h3>
          <p class="sub-title">Expert Team</p>
          <p class="sub-title-f">【专业呵护 专注完美】</p>
          <el-carousel  arrow="always" ref="team" height="413px" indicator-position="none" :autoplay="false">
            <el-carousel-item v-for="item in klList" :key="item.id" name="item.id">
              <div class="kl-in">
                <div class="kl-img-box">
                  <img :src="item.src" class="kl-img" alt="">
                </div>
                <div class="kl-content">
                  <h3 class="kl-title">{{item.title}}</h3>
                  <div class="kl-article" v-html="item.content"></div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
          <div class="toggle-box">
            <ul class="kl-team">
              <li class="team-item" v-for="item in teamList" :key="item.id" @click="toggleTeam(item.id)">
                <div class="team-box">
                  <img :src="item.src" alt="">
                </div>
                <p class="team-title">{{item.name}}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="container video">
        <h3 class="meal-title"><span class="title-line"></span>最新动态<span class="title-line"></span></h3>
        <p class="sub-title">News  information</p>
        <p class="sub-title-f">【科学月子 为爱护航 】</p>
        <div class="content">
          <div class="video-part">
            <router-link to="">
              <img src="../../static/img/index/banner-dynamic.png" alt="">
            </router-link>
          </div>
          <div class="video-list-part">
            <ul>
              <li class="video-list-item" v-for="item in lastDyn" :key="item.id" @click="toDetail(item.id)">
                  <img :src="item.picUrl" alt="">
                  <div class="list-info">
                    <p class="video-title one-line">{{item.name}}</p>
                    <p class="video-sub one-line">{{item.content}}</p>
                  </div>
              </li>
            </ul>
          </div>
          <div style="clear:both;"></div>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "main",
      data() {
        return {
          index:1,
          tabPosition: 'all',
          activeName:'second',
          diaryCarList:[
            {
              name:'阶段式科学坐月子 ',
              id:1
            },
            {
              name:'合美韩式无痛开奶 ',
              id:2
            },
            {
              name:'“纤之韵”品牌产康',
              id:3
            },
            {
              name:'古法创新纤体塑形',
              id:4
            },
            {
              name:'台式科学月子膳食',
              id:5
            }
          ],
          diaryList:[
            {
              id:1,
              src:'../../static/img/index/banner-special.png',
              title:'阶段式科学坐月子',
              content:'从分娩结束到产妇身体恢复正常，一般需6~8周，这个阶段医学上称为产褥期，民间俗称“坐月子。合美以“阶段式月子模式+管家式贴心服务”（脆弱期、过渡期、成熟期1v1照护，配合科学膳食“一清”“二调”“三补“”四强化”进食原则）为特色提供更科学、更安心的月子照顾。让每位妈妈吃得科学又专业，更是保证产后奶水及身体调理的前提，配合上适量美体训练，增强自身机能，突显康复效果，恢复健康好身材。'
            },
            {
              id:2,
              src:'../../static/img/index/banner-special-2.png',
              title:'合美韩式无痛开奶',
              content:'合美韩式无痛乳房管理是一套综合性独特开奶、乳房疾病管理方法。通过对组织和穴位进行轻柔和按摩，促进血液循环，有助于充分增加泌乳并且缓解乳房疼痛现象。其特色与传统开奶最大的区别在于乳房管理的无痛感，让宝宝第一时间喝到妈妈的母乳，解决喂养问题；专业医生也将向新妈妈普及喂养知识，指导解决乳头皲裂、乳晕周围损伤、乳腺炎等问题。'
            },
            {
              id:3,
              src:'../../static/img/index/banner-special-3.png',
              title:'“纤之韵”产后修复',
              content:'合美特色产后康复品牌“纤之韵”由留美医学博士、和睦家产康专家张晓东博士定期坐诊，携团队康复治疗师及护理师为孕妈深度解决剖析问题，制定康复计划，提供顶级专业的服务。“纤之韵”产后康复项目包括臀部恢复、盆骨矫正、盆骨肌腹直肌修复、脊柱综合修复、全身淋巴疏通等，全面为产后妈妈预防体型发胖、体质变弱、产后疼痛等问题。'
            },
            {
              id:4,
              src:'../../static/img/index/banner-special-4.png',
              title:'古法新创产后纤体塑形',
              content:'合美产后形体修复以专业按摩手法、配合中医点穴与塑腹技巧，使产后腹部上变大变松的脂肪粒压缩变小变实，增加弹性纤维的韧性以及表皮的弹性，使腰部结实；在印尼古法基础上依据产后妈妈整体身体结构设计改良，配合修复主打产品“JAMU”“CHIMU”黑科技局部紧致，帮助新妈妈快速恢复，完美纤体，重归自信。 '
            },
            {
              id:5,
              src:'../../static/img/index/banner-special-5.png',
              title:'引进台式科学月子膳食',
              content:'合美台式月子餐采取“一清、二调、三补、四强化”的食疗原则分阶段进行，打破传统误区，科学搭配膳食。由专业营养师及台湾著名月子餐药膳调理师采用药食同源的方式为妈妈们量身定制月子餐，促进伤口愈合，进补气血调理体质，美容降脂强化。每日三次主食、三次点心，上百样菜式确保28天不重复，让妈妈们吃出美丽，吃出健康。'
            },
          ],
          jxServer:[
            {
              id:1,
              name:'出院专车入所陪护',
              content:'入住合美月子中心的宝妈享受全程专车接送出院入所服务，让每一位宝妈入所无忧。',
              picUrl:'../../static/img/index/jx/01.jpg'
            },
            {
              id:2,
              name:'家属陪伴特定餐食',
              content:'月子期间，宝妈家属享受每日3餐免费供应服务（限1人）；<br>\n' +
                '让爱的陪伴更有温度。',
              picUrl:'../../static/img/index/jx/02.jpg'
            },
            {
              id:3,
              name:'孕期写真新生儿照',
              content:'孕期写真          \n' +
                '*2组服装     \n' +
                '*10寸摆台\n' +
                '*5张精修\n' +
                '\n<br>' +
                '新生儿照\n' +
                '*2组服装\n' +
                '*8寸实木相框\n' +
                '*5张精修',
              picUrl:'../../static/img/index/jx/03.jpg'
            },
            {
              id:4,
              name:'新手爸妈免费课堂',
              content:'专家亲授新生儿护理小常识，宝妈产康小技巧，get专业知识，让新手爸妈不迷茫',
              picUrl:'../../static/img/index/jx/04.jpg'
            },
          ],
          meatListA:[
            {
              id:1,
              src:'../../static/img/index/a/a-1.jpg',
              title:'优享套餐',
              occupancy:'21天 38m²套房 朝北%',
              sub:'高性价比  众多妈妈力推爆款'
            },
            {
              id:2,
              src:'../../static/img/index/a/a-2.jpg',
              title:'悦享套餐',
              occupancy:'21天 42m²套房 朝东',
              sub:'经典房型  温馨超值修养套餐'
            },
            {
              id:3,
              src:'../../static/img/index/a/a-3.jpg',
              title:'尊享套餐',
              occupancy:'21天 57m²套房 朝北',
              sub:'顶级配置 一对一专业全天呵护'
            },
            {
              id:4,
              src:'../../static/img/index/a/a-4.jpg',
              title:'臻享套餐',
              occupancy:'21天 75m²套房 朝南',
              sub:'限量专享 超大空间满足全家需求'
            },
          ],
          meatListB:[
            {
              id:1,
              src:'../../static/img/index/env-1.png',
              title:'5A景区绿植覆盖空气清新天然氧吧',
              occupancy:'100%',
            },
            {
              id:2,
              src:'../../static/img/index/env-2.png',
              title:'家庭式入驻阳台视野开阔明亮',
              occupancy:'100%',
            },
            {
              id:3,
              src:'../../static/img/index/env-3.png',
              title:'四周幽雅宁静适宜修养',
              occupancy:'100%',
            },
            {
              id:4,
              src:'../../static/img/index/env-4.png',
              title:'文化氛围浓厚周边无商业大厦',
              occupancy:'100%',
            },
          ],
          meatListC:[
            {
              id:1,
              src:'../../static/img/index/c/c-1.jpg',
              title:'室内风格简洁舒适 生活设备齐全',
              occupancy:'100%',
            },
            {
              id:2,
              src:'../../static/img/index/c/c-2.jpg',
              title:'温馨私密空间的现代化月子中心',
              occupancy:'100%',
            },
            {
              id:3,
              src:'../../static/img/index/c/c-3.jpg',
              title:'月子房带露天阳台居住更舒心',
              occupancy:'100%',
            },
            {
              id:4,
              src:'../../static/img/index/c/c-4.jpg',
              title:'总占地面积3000平米 特设10间功能房',
              occupancy:'100%',
            },
          ],
          meatListD:[
            {
              id:1,
              src:'../../static/img/index/d/d-1.jpg',
              title:'宝宝护理站三甲医院级医疗洁净板防菌零感染加 落地隔音玻璃式设计',
              occupancy:'100%',
            },
            {
            id:2, 
              src:'../../static/img/index/d/d-2.jpg',
              title:'恒温恒湿瑜伽房 专业老师个性化定制课程轻松恢复好身材',
              occupancy:'100%',
            },
            {
              id:3,
              src:'../../static/img/index/d/d-3.jpg',
              title:'活动室开展绘画烘焙手工课、座谈会派对 打造丰富多彩月子生活',
              occupancy:'100%',
            },
            {
              id:4,
              src:'../../static/img/index/d/d-4.jpg',
              title:'婴儿游泳专区健康师协助宝宝游泳沐浴抚触 尽享舒适健康 ',
              occupancy:'100%',
            },
          ],
          cardList:[
            {
              src:'./static/img/card1.png',
              article:'第二次入住爱帝宫的月子生活<br>' +
                '产后瑜伽和无痛通乳是亮点！'
            },
            {
              src:'./static/img/card2.png',
              article:'第二次入住爱帝宫的月子生活<br>' +
                '产后瑜伽和无痛通乳是亮点！'
            },
            {
              src:'./static/img/card3.png',
              article:'第二次入住爱帝宫的月子生活<br>' +
                '产后瑜伽和无痛通乳是亮点！'
            },
          ],
          klList:[
            {
              id:1,
              title:"妇产科临床工作20余年、产科副主任——周小珏",
              content:'具备扎实的理论基础与丰富的临床经验，擅长孕产妇保健及难产处理、诊治各类妊娠合并症及并发症。尤其对危重孕产妇抢救合高难度产科手术有丰富临床经验。曾参与江苏省卫计委援陕医疗队，发表多篇核心论文。',
              src:'../../static/img/index/member-1.png'
            },
            {
              id:2,
              title:"合美店长、29年新生儿护理、产康经验——叶蓉",
              content:'历任常州市儿童医院新生儿护理组长、新寰亚月子会所护士长、孕产妇健康教育讲师。接受过多项专业技术特殊训练（产后修复技术、新生儿护理及重儿抢救、婴幼儿高压氧舱操作技术等）。并屡获优秀护士、嘉奖等表彰与奖励，期间多次荣立“三等功”，发表省级论文数篇。管理中注重团队建设、以精细化管理不断开拓创新。',
              src:'../../static/img/about/01.png'
            },
            {
              id:3,
              title:"特邀留美医学博士、和睦家产康专家、中美职业资质医师——张晓东",
              content:'作为中美两国职业资质医师、康复科医师，曾留学美国德克萨斯派克脊柱神经矫正康复研究院，开设私人诊所，并为国内外数位明星妈妈提供产康解决方案。张晓东博士及其团队在合美定期坐诊，提供包括皮肤管理、臀部修复、产后骨盆恢复、产后腹部恢复、产后脊柱康复等专业产康服务；除常规的骨伤康复和脊柱康复，张博士擅长中西医结合产后康复治疗，运用美国Thompson技术，将理疗、整骨、胶原蛋白导入相结合，再通过理疗和专业整骨手法，让骨盆恢复其自然生理机能，彻底为孕妈深度剖析问题制定康复计划。',
              src:'../../static/img/about/04.png'
            },
            {
              id:4,
              title:"高级营养师+星级大厨",
              content:'合美科学膳食由五星级酒店行政总厨率资深厨师、并聘请营养专家共同组成，进行产品开发、食材选择、营养调配、菜品烹制。并针对孕产妇个体差异，为其量身定制个性营养月子餐及药膳调理，为产妇提供餐餐不同、阶段补养，吃出苗条，吃出健康。',
              src:'../../static/img/about/06.png'
            },
            {
              id:5,
              title:"强强联合铸造合美实力",
              content:'合美月子中心与北京和睦家双方已达成共识，拟在孕产健康咨询、早产儿健康护理、产后康复体验等多个方面展开深度合作，共同发展推进功能完善、体验一流、健康引领的母婴医疗服务体系。\n' +
                '<br>' +
                '合美将以国际化的医疗团队、独有的私家母婴护理，尽心为产后母婴健康提供更科学与高水平的医疗保健服务，以全新理念、专业技术、优质资源引领母婴生活方式的变革。',
              src:'../../static/img/about/05.png'
            },
          ],
          teamList:[
            {
              id:1,
              src:'../../static/img/index/member-1.png',
              name:'二十载专业成就卓越品质'
            },
            // {
            //   id:2,
            //   src:'../../static/img/about/01.png',
            //   name:'顶级专业医护团队'
            // },
            {
              id:3,
              src:'../../static/img/about/04.png',
              name:'合美产后康复王牌团队'
            },
            {
              id:4,
              src:'../../static/img/about/06.png',
              name:'高级营养师+星级大厨'
            },
            {
              id:5,
              src:'../../static/img/about/05.png',
              name:'强强联合铸造合美实力'
            },
          ],
          honorList:[
            {
              cate:'口碑',
              content:'20000 <span style="font-size: 16px">个</span>',
              sub:'育儿家庭'
            },
            {
              cate:'经验',
              content:'13 <span style="font-size: 16px">年</span>',
              sub:'月子护理经验'
            },
            {
              cate:'科学',
              content:'12 <span style="font-size: 16px">对</span>1',
              sub:'全面护理'
            },
            {
              cate:'荣誉',
              content:'20 <span style="font-size: 16px">多个</span>',
              sub:'行业奖状'
            },
          ],
          spList:[
            {
              id:1,
              img:'./static/img/sps-1.png',
              name:'出院专车入所陪护 ',
              ifHide:false
            },
            {
              id:2,
              img:'./static/img/sps-2.png',
              name:'家属陪伴特定餐食 ',
              ifHide:true
            },
            {
              id:3,
              img:'./static/img/sps-3.png',
              name:'孕期写真新生儿照 ',
              ifHide:true
            },
            {
              id:4,
              img:'./static/img/sps-4.png',
              name:'新手爸妈免费课堂',
              ifHide:true
            },
          ],
          lastDyn:[
            {
              id:'a-1',
              name:'在台式月子会所坐月子的优势有哪些',
              content:'在这个科学的时代中，大家都认为在台式月子会所能够享用到更科学合理的护理。服务较好的台式月子会所能使大家得到身体需求的充沛调养',
              picUrl:'../../static/img/dynamic/dy-2.png'
            },
            {
              id:'a-2',
              name:'产后修复不盲目丨认识它，才能选对它',
              content:'在这个科学的时代中，大家都认为在台式月子会所能够享用到更科学合理的护理。',
              picUrl:'../../static/img/dynamic/list/1.jpg'
            },
            {
              id:"b-1",
              name:'关于“专业”我们是认真的！',
              content:'在这个科学的时代中，大家都认为在台式月子会所能够享用到更科学合理的护理。服务较好的台式月子会所能使大家得到身体需求的充沛调养',
              picUrl:'../../static/img/dynamic/00.jpg'
            },
            {
              id:"c-1",
              name:'合美月子中心周年庆',
              content:'在这个科学的时代中，大家都认为在台式月子会所能够享用到更科学合理的护理。服务较好的台式月子会所能使大家得到身体需求的充沛调养',
              picUrl:'../../static/img/dynamic/dy-5.jpg'
            },
          ]
        };
      },
      methods:{
        toDetail:function(id){
          this.$router.push({
            path: `/dynamicDetail/${id}`,
          })
        },
        setActive:function (id) {
          this.index = id;
          this.$refs.diaryCar.setActiveItem(id-1)
        },
        toggleTeam:function(id){
          this.index = id;
          this.$refs.team.setActiveItem(id-1)
        },
        setActiveS:function (id) {
          for(var i=0;i<this.spList.length;i++){
            this.spList[i].ifHide = true;
            if(i ===id){
              this.spList[i].ifHide = false;
            }
          }
          this.$refs.carousels.setActiveItem(id)
        }
      }
    }
</script>

<style scoped lang="less">
  .main{
    .banner{
      border-bottom: 1px solid #e6e6e6;
      position: relative;
      h1{
        position: absolute;
        left: -9999px;
      }
      img{
        width: 100%;
        min-width: 1250px;
      }
      ul{
        margin-top: -2px;
        .server-nine{
          text-align: center;
          float: left;
          width: 173px;
          height: 100px;
          border-right: 1px solid #e6e6e6;
          font-size: 16px;
          cursor: pointer;
          overflow: hidden;
          &:first-child{
            border-right: none;
          }
          &:hover{
            .cate-icon{
              transform: translateY(-96px);
            }
          }
          .cate-icon{
            transition: all 0.5s ease;
            display: block;
            width: 172px!important;
            margin:0 auto 10px;
            min-width: auto;
          }
          .transition{
            width: 100%;
            height: 100%;
            transition: all 0.5s;
          }
        }
        .server-nine.first{
          background-color: #f5eef5;
          color:#725973;
          font-size: 24px;
          padding: 18px;
        }
      }
    }
    .meal{
        padding: 70px 0 80px;
        background: url("../../static/img/index/bg-1.png");
        -webkit-background-size: cover;
        background-size: cover;

      .el-radio-group{
        display: flex;
        justify-content: center;
        margin:0 auto 20px!important;
        // .el-radio-button__inner{

        // }
        .el-radio-button__orig-radio:checked+.el-radio-button__inner{
          background-color: #fff!important;
          color:#f79200;
        }
      }
      .ab-containers{
        .flex-content{
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          .envi{
            background-color: #fff;
            display: inline-block;
            width: 297px;
            border: 1px solid #e5e5e5;
            height: 383px;
            text-align: center;
            img{
              width: 100%;
              height: 209px;
              margin-bottom: 18px;
            }
            .env-name{
              font-size: 16px;
              height: 42px;
              display: block;
              font-weight: bold;
            }
            .env-info{
              display: block;
              margin:0 auto 10px;
              width: 240px;
              font-size: 14px;
              color:#666666;
              span{
                color:#f79200;
              }
            }
            .el-button{
              border: 1px solid #000;
              color: #111111;
            }
          }
        }
      }
    }
    .diary{
      padding: 70px 0 80px;
      .taggle-box{
        margin-bottom: 40px;
        ul{
          display: flex;
          flex-direction: row;
          justify-content: center;
          .fun-carousel{
            float: left;
            cursor: pointer;
            .active{
              color:#F79200;
            }
            span{
              margin:0 10px
            }
          }
          .fun-carousel.active{
            color:#f79200;
          }
        }
      }
      .el-carousel{
        margin-bottom: 40px;
        .diary-carousel{
          position: relative;
          width: 100%;
          height: 100%;
          img{
            width: 100%;
            height: 100%;
          }
          .diary-content{
            position: absolute;
            left: 60px;
            top: 70px;
            width: 468px;
            .diary-title{
              font-weight: normal;
              font-size: 24px;
              margin-bottom: 20px;
            }
            .diary-article{
              margin-bottom: 10px;
              font-size: 14px;
              line-height: 28px;
              color:#666666;
            }
            .el-button{
              float: right;
              background-color: transparent;
              border-color: #333333;
              color:#333333;
              line-height: 32px;
              height: 32px;
              padding-top: 0;
              padding-bottom: 0;
            }
          }
        }
      }
    }
    .sp-server{
      background: url("../../static/img/special.png") no-repeat center;
      width: 100%;
      height: 600px;
      -webkit-background-size: 100% 100%;
      background-size: 100% 100%;
      .content{
        height: 600px;
      }
      .left-part{
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        float: left;
        width: 600px;
        height: 100%;
        color: #ffffff;
        .server-title{
          font-size: 50px;
          margin-bottom: 30px;
        }
        .server-intro{
          font-size: 20px;
          margin-bottom: 40px;
        }
        .colocation{
          padding:  0 138px;
          .colo-item{
            position: relative;
            float: left;
            margin:0 100px 30px 0;
            &:nth-child(2n){
              margin-right: 0;
            }
            .out-img{
              width: 78px;
              height: 78px;
              border-radius: 50%;
              overflow: hidden;
              border: 2px solid #F79200;
              margin: 0 auto 15px;
              img{
                width: 78px;
                height: 78px;
              }
              .hide{
                display: block;
                position: absolute;
                left: 17px;
                top: 0;
                border-radius: 50%;
                width: 78px;
                height: 78px;
                background-color: rgba(0,0,0,0.3);
              }
            }

            p{
              width: 112px;
            }

          }
        }
      }
      .right-part{
        float: left;
        width: calc(100% - 605px);
        height: 100%;
        .right-content{
          float: right;
          margin-top: 74px;
          background-color: #fff;
          width: 603px;
          height: 452px;
          padding: 40px;
          .right-title{
            display: flex;
            margin-bottom: 20px;
            justify-content: center;
            font-size: 24px;
            .title-line{
              width: 60px;
              height: 1px;
              display: block;
              background-color: #cccccc;
              margin:16px  10px;
            }
          }

          .sp-article{
            text-align: center;
            height: 100px;
            line-height: 26px;
          }

          .img-part{
            display: flex;
            justify-content: center;
            img{
              width: 353px;
              height: 230px;
            }
          }
        }
      }
    }
    .knowledge{
      background-color: #f5f5f5;
      padding: 80px 0;
      .el-carousel{
        margin-bottom: 20px!important;
        .el-carousel__item{
          padding: 0 60px!important;
        }
        .el-carousel__arrow--left,.el-carousel__arrow--right{
          width: 30px!important;
          height: 64px!important;
          background-color: #fff!important;
        }
      }
      .kl-in{
        background-color: #fff;
        width: 100%;
        .kl-img-box{

          margin-right: 65px;
          width: 418px;
          height: 413px;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          .kl-img{
            display: inline-block;
          }
        }

        .kl-content{
          width: 588px;
          vertical-align: top;
          padding-top: 68px;
          display: inline-block;
          .kl-title{
            font-size: 24px;
            color:#333333;
            margin-bottom: 28px;
          }
          .kl-article{
            font-size: 14px;
            line-height: 28px;
            color:#666666;
          }
        }
      }
      .toggle-box{
        width: 100%;
        height: 150px;
        .kl-team{
          display: flex;
          justify-content: space-between;
          .team-item{
            background-color: #fff;
            cursor: pointer;
            transition: all 0.3s ease;
            flex: 1;
            margin-right: 10px;
            height: 150px;
            display: flex;
            flex-direction: column;
            justify-content: left;
            &:last-child{
              margin-right: 0;
            }
            &:hover{
              -webkit-transform: scale(1.1);
              -moz-transform: scale(1.1);
              -ms-transform: scale(1.1);
              -o-transform: scale(1.1);
              transform: scale(1.1);
            }
            .team-box{
              display: flex;
              justify-content: center;
              align-items: center;

              width: 100%;
              height: 100%;
              img{
                height: 120px;
                background-color: #43484c;
              }
            }

            .team-title{
              display: block;
              background-color: #a2774d;
              text-align: center;
              color: #ffffff;
              line-height: 30px;
              width: 100%;
              height: 30px;
            }
          }

        }
      }
    }
    .video{
      padding: 80px 0;
      .video-part{
        float: left;
        width: 805px;
        height: 450px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .video-list-part{
        float: left;
        width: calc(100% - 805px);
        height: 450px;
        border: 1px solid #e5e5e5;
        border-left: none;
        padding: 10px 34px;
        .video-list-item{
          height: 100px;
          padding: 20px;
          border-bottom: 1px solid #e5e5e5;
          cursor: pointer;
          transition: all 0.5s;
          img{
            width: 90px;
            height: 60px;
            display: inline-block;
            margin-right: 23px;
          }
          .list-info{
            float: left;
            width: 200px;
            padding: 4px 0;
            .video-title{
              font-size: 16px;
              margin-bottom: 8px;
            }
            .video-sub{
              color:#999999;
              font-size: 14px;
            }
          }
          &:hover{
            background-color: #f4e8d7;
            -webkit-transform: translateY(-5px);
            -moz-transform: translateY(-5px);
            -ms-transform: translateY(-5px);
            -o-transform: translateY(-5px);
            transform: translateY(-5px);
          }
          &:last-child{
            border-bottom: none;
          }
        }
      }
    }
    .understand{
      padding: 80px 0;
      background-color: #f8f8f8;
      .card-box{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .card{
          background-color: #fff;
          width: 402px;
          height: 365px;
          img{
            display: block;
            width: 100%;
            height: 268px;
          }
          .card-article{
            padding: 24px 30px;
            font-size: 16px;
            line-height: 24px;
          }
        }
      }
    }
    .honor{
      height: 250px;
      padding: 60px 0;
      background: url("../../static/img/data-bg.png") no-repeat;
      -webkit-background-size: 100%  100%;
      background-size: 100% 100%;
      .content{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .honor-item{
          width: 25%;
          height: 130px;
          padding: 0 80px;
          border-left: 1px solid #c29f6e;
          color:#ffffff;
          &:first-child{
            border-left: none;
          }
          .honor-cate{
            border: 1px solid #ffffff;
            border-radius: 4px;
            padding: 2px 8px;
            display: inline-block;
            margin-bottom: 15px;
          }
          .result{
            font-size: 36px;
            margin-bottom: 12px;

          }
          .sub-result{
            font-size: 16px;
          }
        }
      }
    }
  }
  .meal-title{
    margin-bottom: 8px;
    text-align: center;
    font-size: 28px;
    line-height: 32px;
    font-weight: 500;
    .title-line{
      width: 65px;
      height: 1px;
      margin:0 30px;
      display: inline-block;
      background-color: #cccccc;
      vertical-align: middle;
    }
  }
  .sub-title{
    margin-bottom: 10px;
    color:#b3b3ba;
    text-align: center;
  }
  .sub-title-f{
    margin-bottom: 38px;
    color:#b3b3ba;
    text-align: center;
  }
</style>
<style lang="less">
  .el-radio-group{
    display: flex;
    justify-content: center;
    margin:0 auto 20px!important;
    .el-radio-button__inner{
      width: 130px;
      &:hover{
        color:#f79200;
      }
    }

  }
  .knowledge{
    .el-carousel{
      .el-carousel__arrow{
        width: 30px;
        height: 64px;
        background-color: #fff!important;
        border-radius: 0;
        i{
          color:#e4ab74;
          font-size: 24px;
        }
      }
    }
  }
  .is-active .el-radio-button__inner{
    background-color: #fff!important;
    color:#f79200!important;
    border-color: #e5e5e5 !important;
    box-shadow: none!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/main.vue